import React, {useState, useEffect} from 'react';
import {Text, View, Dimensions} from 'react-native';
import HomeHeader from '../../components/HomeHeader';

const HEIGHT = Dimensions.get('window').height;

export default function AboutUsScreen(props) {

  return (
    <View
      style={{
        height: HEIGHT,
      }}>
      <HomeHeader navigation={props.navigation}/>
      <Text>About us</Text>
    </View>
  );
}
